/* Minsenzia newsletter capture — progressive enhancement.
   The native {% form 'customer' %} is the no-JS fallback (creates a Shopify
   subscriber with marketing consent). When JS runs, we intercept the submit and
   subscribe the email DIRECTLY to the Newsletter list (WMXgtD) via the Klaviyo
   Client API — the same proven pattern as the Planner waitlist
   (assets/minsenzia-planner.js, list SdQqpy) — so the "Added to List" Welcome
   flow fires. Public company_id SRHQED is safe to expose. In-page, no pop-ups,
   no third-party embed. Config + localized copy arrive via [data-ms-*] on a
   wrapper around each form. */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var wraps = document.querySelectorAll('[data-ms-klaviyo]');
  if (!wraps.length) return;

  wraps.forEach(function (wrap) {
    if (wrap.hasAttribute('data-ms-bound')) return;
    var form = wrap.querySelector('form');
    if (!form) return;
    var input = form.querySelector('input[type="email"]');
    if (!input) return;
    var btn = form.querySelector('button[type="submit"]') || form.querySelector('button');
    // Transient-error line lives OUTSIDE the form so it survives form clearing.
    var msg = wrap.querySelector('[data-ms-msg]');
    wrap.setAttribute('data-ms-bound', '');

    var listId = wrap.getAttribute('data-ms-list');
    var source = wrap.getAttribute('data-ms-source') || 'Website';
    var redirect = wrap.getAttribute('data-ms-redirect');         // desk-reset only
    var successClass = wrap.getAttribute('data-ms-success-class') || '';
    var txt = {
      success: wrap.getAttribute('data-ms-success') || '',
      errEmail: wrap.getAttribute('data-ms-err-email') || '',
      errFail: wrap.getAttribute('data-ms-err-fail') || '',
      sending: wrap.getAttribute('data-ms-sending') || ''
    };
    // Icon-only buttons (e.g. footer arrow) have no text — never wipe their SVG.
    var hasBtnText = !!btn && btn.textContent.trim().length > 0;
    var sending = false;

    function showMsg(text) { if (msg) { msg.textContent = text; } }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;

      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showMsg(txt.errEmail);
        input.focus();
        return;
      }

      sending = true;
      var origLabel = null;
      if (btn) {
        btn.disabled = true;
        if (hasBtnText && txt.sending) { origLabel = btn.textContent; btn.textContent = txt.sending; }
      }
      input.disabled = true;
      showMsg('');

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=SRHQED', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-04-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).then(function (res) {
        if (!res.ok) { recover(); return; }
        if (redirect) { window.location.replace(redirect); return; }
        // Success in place: clear the form, show the success line (same as Planner).
        form.innerHTML = '';
        var done = document.createElement('p');
        if (successClass) { done.className = successClass; }
        done.setAttribute('role', 'status');
        done.setAttribute('aria-live', 'polite');
        done.textContent = txt.success;
        form.appendChild(done);
        showMsg('');
      }).catch(recover);

      function recover() {
        sending = false;
        if (btn) {
          btn.disabled = false;
          if (origLabel !== null) { btn.textContent = origLabel; }
        }
        input.disabled = false;
        showMsg(txt.errFail);
      }
    });
  });
})();
